// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3xXlv","errors":"Errors_errors__30vgt"};